module.exports = __webpack_public_path__ + "static/media/student_portrait.3b326420.svg";